const { createClient } = require('@sejazipper/layer-api-client');

const MASTER_URI = 'https://master.zipper.solutions/graphql';

const uri = process.env.VUE_APP_LAYER_URL
  ? process.env.VUE_APP_LAYER_URL
  : MASTER_URI;

/**
 * @type {import('@sejazipper/layer-api-client').Client}
 */
let client;

export const useZipperApi = () => {
  const accessToken = localStorage.getItem('access_token');
  if (!client) {
    client = createClient({
      url: uri,
      headers: {
        Authorization:
            `Bearer ${accessToken}` || '',
      },
    });
  }
  return {
    client,
  };
};
